import type { MergedMarketRecord } from '@/types/market';
import type { ScoreBand } from '@/types/insights';
import { clamp } from '@/utils/numbers';
import { scoringWeights } from '@/config/scoringWeights';
import { magnitudeBand } from './bands';

/**
 * confidenceScore: 0..100, how much statistical trust to place in this
 * geography's scores -- driven by how complete the resolved field set is
 * and how many independent sources corroborate it. Deliberately does NOT
 * penalize for isSampleData; that is a separate, explicit "this is
 * placeholder data" signal shown directly in the UI (see freshness badge),
 * not folded silently into a numeric score.
 */
export function computeConfidenceScore(record: MergedMarketRecord): ScoreBand {
  const w = scoringWeights.confidence;
  const completeness = record.resolved.fieldCompleteness ?? 0;
  const sourceCount = record.contributingSources.length;

  const scaled = clamp(completeness * w.completenessWeight + sourceCount * w.perSourceWeight, 0, 100);
  return magnitudeBand(scaled);
}
